import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { makeCutoffOrZscoreIntersectionValidator } from 'utilities/validators';

import ZScoreFieldsComponent from './Component';

import getDistributionFunctionsByType from 'calculators/distributions';
import { setCutoffs } from 'store/scenes/distributions/cutoffs/actions';
import { getCutoffs } from 'store/scenes/distributions/cutoffs/selectors';

import {
  setAlpha,
  setLeftCutoff, setRightCutoff
} from 'store/form/distributions/actions';

import {
  getTailType, isLeftTailSelected, isRightTailSelected
} from 'store/scenes/distributions/chart/selectors';

import { round5 } from 'utilities/math';

import {
  getRightZScore,
  getLeftZScore,

  getDistributionsType,
  getDistributionsFormValues
} from 'store/form/distributions/selectors';

class ZScoreFieldsContainer extends React.PureComponent {
    validateRightZScoreFn = (value, allValues = { leftZScore: this.props.leftZScore }) => {
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +allValues.leftZScore,
        +value,
        this.props.tailType
      );

      return intersectValidator;
    };

    validateLeftZScoreFn = (value, allValues = { rightZScore: this.props.rightZScore }) => {
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +value,
        +allValues.rightZScore,
        this.props.tailType
      );

      return intersectValidator;
    };

    handleLeftZScoreChange = (_, newLeftZScore) => {
      this.props.recalculateAlphaAndCutoffs({
        type: 'left', value: newLeftZScore
      });
    };

    handleRightZScoreChange = (_, newRightZScore) => {
      this.props.recalculateAlphaAndCutoffs({
        type: 'right', value: newRightZScore
      });
    };


    render () {
      return (
        <ZScoreFieldsComponent
          isLeftZScoreFieldVisible={this.props.isLeftZFieldVisible}
          isRightZScoreFieldVisible={this.props.isRightZFieldVisible}
          isCenterChosen={this.props.isCenterChosen}

          onLeftZScoreChange={this.handleLeftZScoreChange}
          onRightZScoreChange={this.handleRightZScoreChange}

          validateLeftZScoreFn={this.validateLeftZScoreFn}
          validateRightZScoreFn={this.validateRightZScoreFn}
        />
      );
    }
}

ZScoreFieldsContainer.propTypes = {
  isLeftZFieldVisible: PropTypes.bool.isRequired,
  isRightZFieldVisible: PropTypes.bool.isRequired,
  isCenterChosen: PropTypes.bool.isRequired,

  recalculateAlphaAndCutoffs: PropTypes.func.isRequired,

  rightZScore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  leftZScore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  tailType: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  isLeftZFieldVisible: isLeftTailSelected(state),
  isRightZFieldVisible: isRightTailSelected(state),
  isCenterChosen: getTailType(state) === 'center',

  rightZScore: getRightZScore(state),
  leftZScore: getLeftZScore(state),

  tailType: getTailType(state)
});

const mapDispatchToProps = {
  recalculateAlphaAndCutoffs: zScore => (dispatch, getState) => {
    const state = getState();
    const tailType = getTailType(state);
    const type = getDistributionsType(state);
    const fns = getDistributionFunctionsByType(type);
    const distributionFormValues = getDistributionsFormValues(state);

    let leftCutoffX = null;
    let rightCutoffX = null;
    let alpha = null;
    let cutoffs = null;
    let recalculateAlpha = null;
    if (type === 'normal') {
      if (zScore.type === 'left') {
        leftCutoffX = fns.getCutoffValueByZScore(distributionFormValues, zScore.value);
        rightCutoffX = getCutoffs(state) && getCutoffs(state).right.x;
      } else {
        rightCutoffX = fns.getCutoffValueByZScore(distributionFormValues, zScore.value);
        leftCutoffX = getCutoffs(state) && getCutoffs(state).left.x;
      }

      alpha = fns.getAlphaByCutoffsAndTailType(distributionFormValues, leftCutoffX, rightCutoffX, tailType);
      cutoffs = fns.getCutoffsByCutoffXValues(distributionFormValues, leftCutoffX, rightCutoffX);

      recalculateAlpha = () => {
        if (round5(alpha) >= 1) {
          return 1;
        }
        if (round5(alpha) <= 0) {
          return 0;
        }
        return round5(alpha);
      };
    }

    dispatch([
      setAlpha(
        recalculateAlpha()
      ),

      setCutoffs(cutoffs),

      setLeftCutoff(leftCutoffX),
      setRightCutoff(rightCutoffX)
    ]);
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ZScoreFieldsContainer
);
